export const COLUMN_TYPES = {
  EMAIL: 'email',
  MIRROR_EMAIL_COLUMN: 'mirror-email-column',
  PEOPLE: 'people',
};